// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2NSa5","title":"BackImages_title__3jkjt","images":"BackImages_images__34rUi"};